<style scoped>
    @import url("../../styles/smartControl/initSC.scss");
</style>

<template>
    <div class="box_initSC">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-view-quilt-outline</v-icon>
            <span class="ml-2">Início</span>
        </div>

        <div class="searchBar mt-1 mb-1" v-if="!flagLoading">
            <div class="elSearch">
                <v-autocomplete
                v-model="execSysPRE"
                :items="liExecSys"
                color="rgb(247,215,46)"
                class="w-100"
                @change="callSearch(execSysPRE)"
                ></v-autocomplete>

                <v-icon @click="callSearch(execSysPRE)"
                size="42"
                class="el_icon_search"
                @mouseover="hoverSearch = 'rgb(31,122,177)'"
                @mouseleave="hoverSearch = '#f39c12'"
                :style="{'color': hoverSearch,'align-self':'center'}">mdi-magnify</v-icon>
            </div>

            <div class="mt-4 ml-3 titSysSelected">Sistema selecionado</div>
            <div class="subTitSys">{{ $store.state.sistemaSC }}</div>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="painelGeral" v-if="!flagLoading">
            <PainelInitSC
            :qntAtuadores="$store.state.tamLiAtuadoresSC" 
            :qntSensores="$store.state.tamLiSensoresSC" />
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import PainelInitSC from './PainelInitSC'

export default {

    components:{PainelInitSC},

    data() {
        return {
            //
            //r:'/dadoslipordia',

            // loading
            flagLoading:true,

            // sistema a ser exibido | serach
            liExecSys:['upinc1'], // ['upinc1','upinc2'],
            emailCliente:'',
            execSys:'Nenhum sistema selecionado', // -- sistema current exib
            execSysPRE:'', // -- selecionado pelo search
            hoverSearch:'#f39c12',

            // info estrutural
            decisorSC:'',
            cultura:'',
            prod:'',
            liAtuadoresSC:'',
            liSensoresSC:'',
            qntAtuadores:0,
            qntSensores:0,
            fusoHorarioSC:'', // recebe fuso do sistema selecionado 02/05/2026
        }
    },

    methods:{

        async getInfoSys(cl, sys) {

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = { 'cliente':cl, 'sistema':sys }
            //console.log('cliente e sistema | params: ',params)

            let self = this

            // ( ! ) return abrigatório para informar a promisse à função chamadora async callSearch().
            return axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                return res.data.result
            })
        },

        preInitS(liS) {

            //let liS = this.$store.state.liSensoresSC
            //let liS = this.liSensoresSC // via props | 20/10/2025
            //console.log('liS [tam]: ',liS.length)

            let qnt_sensores=0
            let c=0
            while (c < liS.length) {
                let liParams = liS[c]['params'] // lista de params do sensor
                let j=0
                while (j < liParams.length) {
                    qnt_sensores++
                    j++
                }
                c++
            }
            return qnt_sensores
        },

        preInitA(liA) {

            //this.qnt_atuadores = this.$store.state.liAtuadoresSC.length
            //console.log('liA [tam]: ',this.$store.state.liAtuadoresSC.length)
            
            //const liA = this.liAtuadoresSC // via props | 20/10/2025
            let qnt_atuadores=0
            let c=0
            while (c < liA.length) {
                let liParams = liA[c]['params'] // lista de params do sensor
                let j=0
                while (j < liParams.length) {
                    if (liParams[j]['status'] == 'on') { qnt_atuadores++; }
                    j++
                }
                c++
            }
            return qnt_atuadores
        },

        async callSearch(valueSelected) { 

            this.flagLoading = true // -- iniciar loading.

            if (valueSelected == '') { 
                this.execSys = 'Nenhum sistema selecionado'
                this.flagLoading = false
                return
            }
            
            //console.log('valueSelected: ',valueSelected); 
            this.execSys = valueSelected

            let el = await this.getInfoSys(this.$store.state.emailCliente, this.execSys)
            //console.log(el)

            //this.decisorSC = el['estrutura']['exec']
            this.culturaSC = el['estrutura']['cultura']
            this.prodSC = el['estrutura']['prod']
            this.liAtuadoresSC = el['atuadores'] // list
            this.liSensoresSC = el['sensores'] // list

            //console.log('this.culturaSC: ',this.culturaSC)

            try {
                this.fusoHorarioSC = el['estrutura']['fuso_horario'] // string | 02/05/2026
                //console.log('[inicioSC] (a) fusoHorarioSC: ',this.fusoHorarioSC)
            } catch (err) {
                this.fusoHorarioSC = "Europe/Lisbon" // default
                //console.log('[inicioSC] (b) fusoHorarioSC: ',this.fusoHorarioSC)
            }

            // -- update nome sistema selecionado no menu superior e persistir sistema para outras pag.
            this.$store.state.sistemaSC = this.execSys
            this.$store.state.decisorSC = this.decisorSC

            this.$store.state.culturaSC = this.culturaSC
            this.$store.state.prodSC = this.prodSC
            this.$store.state.liAtuadoresSC = this.liAtuadoresSC
            this.$store.state.liSensoresSC = this.liSensoresSC
            this.$store.state.fusoHorarioSC = this.fusoHorarioSC // 02/05/2026

            localStorage.setItem('sistemaSC', JSON.stringify(this.execSys))
            //localStorage.setItem('decisorSC', JSON.stringify(this.decisorSC))

            localStorage.setItem('culturaSC', JSON.stringify(this.culturaSC))
            localStorage.setItem('prodSC', JSON.stringify(this.prodSC))
            //localStorage.setItem('liAtuadoresSC', JSON.stringify(this.liAtuadoresSC))
            //localStorage.setItem('liSensoresSC', JSON.stringify(this.liSensoresSC))

            localStorage.setItem('fusoHorarioSC', JSON.stringify(this.fusoHorarioSC)) // 02/05/2026

            // 23/10/2025 (abordagem mais leve para o storage)
            this.qntAtuadores = this.preInitA(this.liAtuadoresSC) // --> props filho
            this.qntSensores = this.preInitS(this.liSensoresSC) // --> props filho
            this.$store.state.tamLiAtuadoresSC = this.qntAtuadores
            this.$store.state.tamLiSensoresSC = this.qntSensores
            localStorage.setItem('tamLiAtuadoresSC', JSON.stringify(this.$store.state.tamLiAtuadoresSC))
            localStorage.setItem('tamLiSensoresSC', JSON.stringify(this.$store.state.tamLiSensoresSC))

            this.flagLoading = false // -- encerrar loading.

            // -- update lista de exibição. 12/08/2025
            // :key="exibKey" faz a mudança quando this.execSys = valueSelected
        },

        toxOff() {

            // -- tox?
            let update_creden = {'flagLogadoDash':false}
            localStorage.setItem('creden', JSON.stringify(update_creden))
            this.$store.state.flagLogadoDash = false // -- desabilitar entrada atual.
            window.location.reload()
        },

        preInit() {

            let emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = { 'cliente': emailCliente }

            let url = self.$store.state.pathAxiosBASE + '/getsysuser' // concat

            axios.post(url, params, {headers})
            .then(function (res) {

                //console.log(res.data.result)
                let lisys = res.data.result
                self.liExecSys = lisys

                self.flagLoading = false // -- encerrar loading
            })
            .catch((error) => {

                self.flagLoading = false

                if (error.response && error.response.status === 401) {

                    self.toxOff()
                    return
                }

                console.log('[preInit] erro:', error)
            })
        },
    },

    created() {
        window.scrollTo(0,0)
        this.preInit()
    }
}
</script>
